/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-object-type */
/**
 * Filters out empty, null, undefined, or empty string values from an object
 * @param obj - The object to filter
 * @returns A new object with only non-empty values
 */
export const filterEmptyValues = <T extends Record<string, any>>(obj: T): Partial<T> => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== undefined && value !== null && value !== '')
  ) as Partial<T>;
};

/**
 * Conditionally includes a property in an object if the condition is truthy
 * @param condition - The condition to check
 * @param key - The property key
 * @param value - The property value
 * @returns An object with the property if condition is truthy, empty object otherwise
 */

export const conditionalProperty = <K extends string, V>(condition: any, key: K, value: V): Record<K, V> | {} => {
  return condition ? { [key]: value } : {};
};
